import React, { memo } from 'react';

export type SourceType = 'corporate' | 'personal' | 'internal' | 'all';

interface SourceToggleProps {
  value: SourceType;
  onChange: (value: SourceType) => void;
}

const SourceToggle = memo<SourceToggleProps>(({ value, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <div className="flex bg-gray-300 rounded-lg p-1">
        <button
          onClick={() => onChange('all')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 hover:shadow-md ${
            value === 'all'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          All
        </button>
        <button
          onClick={() => onChange('corporate')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 hover:shadow-md ${
            value === 'corporate'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Corporate
        </button>
        <button
          onClick={() => onChange('personal')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 hover:shadow-md ${
            value === 'personal'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Personal
        </button>
        <button
          onClick={() => onChange('internal')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 hover:shadow-md ${
            value === 'internal'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Internal
        </button>
      </div>
    </div>
  );
});

SourceToggle.displayName = 'SourceToggle';

export default SourceToggle;
